import { UseQueryResult } from "@tanstack/react-query";
import client, { moreMemoryApiClient } from "../client";
import { useBuildingQuery } from "@/components/RouterSetup";

export type CardMigrationRowStatus =
  "would_migrate" | "migrated" | "skipped" | "failed";

export type CardMigrationRowInput = {
  rowNumber: number;
  email?: string;
  welcomeId?: string;
  accessCardNumber?: string;
  pinCode?: string;
};

export type CardMigrationRowOutcome = {
  rowNumber: number;
  email?: string;
  welcomeId?: string;
  accessCardNumber: string;
  status: CardMigrationRowStatus;
  reason?: string;
  message?: string;
  badgeId?: string;
};

export type CardMigrationFormat = { key: string; label: string };

export type CardMigrationOptions = {
  formatKey: string;
  allowExistingCards: boolean;
  dryRun: boolean;
};

export const useCardMigrationFormats = (): UseQueryResult<
  CardMigrationFormat[]
> =>
  useBuildingQuery({
    queryKey: ["cardMigration", "formats"],
    queryFn: async () => {
      const response = await client.get("/cardMigration/formats");
      return response.data.formats;
    },
    staleTime: Infinity,
  });

export const migrateCardMigrationBatch = async (
  options: CardMigrationOptions,
  rows: CardMigrationRowInput[],
): Promise<CardMigrationRowOutcome[]> => {
  const response = await moreMemoryApiClient.post("/cardMigration/batch", {
    ...options,
    rows,
  });
  return response.data.rows;
};
